import { useMemo } from 'react';
import Fuse from 'fuse.js';
import { Artist } from '../types/artist';

export function useFuzzySearch(artists: Artist[], query: string): Artist[] {
  const fuse = useMemo(() => {
    return new Fuse(artists, {
      keys: ['name', 'sortName'],
      threshold: 0.4,
      includeScore: true,
      minMatchCharLength: 2,
    });
  }, [artists]);

  return useMemo(() => {
    if (!query || query.trim().length < 2) return artists;
    return fuse.search(query.trim()).map(r => r.item);
  }, [fuse, query, artists]);
}
